var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateTask2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1264",
    "data-name": "Group 1264",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.978,
    height: 25.32,
    viewBox: "0 0 19.978 25.32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_694",
    "data-name": "Rectangle 694",
    width: 19.977,
    height: 25.32,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1263",
    "data-name": "Group 1263",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M4.2,44.134l0,0c.019-.03.039-.061.06-.09-.019.026-.037.054-.056.082l-.007.012",
    transform: "translate(-3.775 -39.596)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M17.143,3.255H15.257v-.6a.643.643,0,0,0,0-.187.757.757,0,0,0-.834-.674c-.241-.01-.5-.01-.8-.01H12.8a.172.172,0,0,1-.017-.033,2.871,2.871,0,0,0-2.159-1.7l-.02-.013L10.565.019,10.521,0H9.592L9.436.035c-.114.025-.228.051-.342.085A2.731,2.731,0,0,0,7.248,1.744l-.023.043H5.752a1.893,1.893,0,0,0-.44.044.707.707,0,0,0-.589.752v.675H3.766c-.348,0-.63.006-.888.006a3.728,3.728,0,0,0-.9.114A2.743,2.743,0,0,0,.77,4.1L.7,4.175c-.018.02-.035.039-.052.061S.6,4.291.578,4.319.539,4.37.52,4.4l-.033.047c-.02.029-.04.06-.06.09l0,0c-.018.028-.036.058-.052.088s-.035.063-.052.094-.025.047-.036.072-.015.03-.023.046L.233,4.9a.277.277,0,0,0-.015.036Q.2,4.969.19,5c-.029.073-.054.146-.077.222a2.709,2.709,0,0,0-.112.7v6.451a5.578,5.578,0,0,1,1.659-1.7V6.051a1.044,1.044,0,0,1,.544-.98.894.894,0,0,1,.083-.04.426.426,0,0,1,.045-.018L2.359,5a.97.97,0,0,1,.2-.042c.275-.015.57-.021.935-.021H4.714V5.948A.913.913,0,0,0,5.766,6.989h8.461c.71,0,1.026-.318,1.026-1.026V4.926h1.075c.42,0,.731.007,1.025.022a1.045,1.045,0,0,1,.966,1.1V22.7a.814.814,0,0,1-.63.873,2.086,2.086,0,0,1-.6.079H2.886c-.06,0-.119,0-.178-.005s-.1-.007-.148-.013A.864.864,0,0,1,2,23.444a.731.731,0,0,1-.141-.126.808.808,0,0,1-.2-.619V19.961A5.577,5.577,0,0,1,0,18.257V22.75a2.384,2.384,0,0,0,.111.781c0,.012.007.024.011.036s.017.047.026.072.017.047.027.071l.011.027.021.048c.012.027.025.054.038.081s.027.053.041.08L.317,24c.01.018.02.036.031.053s.026.043.04.065c.024.037.049.074.076.11a2.422,2.422,0,0,0,.693.633,2.967,2.967,0,0,0,1.03.411l.012,0a4.055,4.055,0,0,0,.626.05H17.153a2.968,2.968,0,0,0,1.669-.463,2.4,2.4,0,0,0,1.155-2.106V5.923a2.753,2.753,0,0,0-2.835-2.668M6.41,5.307V3.445H7.65a.92.92,0,0,0,1.026-.8h0A1.432,1.432,0,0,1,10.025,1.6h.1A1.468,1.468,0,0,1,11.4,2.713a.892.892,0,0,0,.965.735h1.209V5.307Z",
    transform: "translate(-0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M65.977,98.564h-.006a.69.69,0,0,1-.655.715,1.505,1.505,0,0,1-.191.007H63.391a5.585,5.585,0,0,0-2.562-1.428h4.2c.1,0,.19,0,.268.007a.7.7,0,0,1,.684.7",
    transform: "translate(-54.691 -87.985)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_662",
    "data-name": "Path 662",
    d: "M65.583,192.425a.725.725,0,0,1-.8.642H60.4a5.586,5.586,0,0,0,2.6-1.43h1.8a.949.949,0,0,1,.22.02.7.7,0,0,1,.559.768Z",
    transform: "translate(-54.304 -172.299)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_663",
    "data-name": "Path 663",
    d: "M59.044,158.8v0Z",
    transform: "translate(-53.086 -142.774)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_664",
    "data-name": "Path 664",
    d: "M103.475,145.558v0l0,0a.714.714,0,0,1-.186.4.786.786,0,0,1-.57.218h-.166a5.631,5.631,0,0,0,.044-.707v-.005a5.607,5.607,0,0,0-.044-.7h.148a1.174,1.174,0,0,1,.157.007.712.712,0,0,1,.621.793",
    transform: "translate(-92.201 -130.15)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_665",
    "data-name": "Path 665",
    d: "M119.967,133.8a.684.684,0,0,0,.483.212.736.736,0,0,0,.464-.18c.085-.07.165-.147.242-.222l.083-.081.509-.483c.49-.464,1-.942,1.491-1.419a.66.66,0,0,0,.149-.846.725.725,0,0,0-.62-.385.63.63,0,0,0-.17.024,1.1,1.1,0,0,0-.433.261c-.446.417-.886.838-1.313,1.246l-.342.332-.181-.165c-.2-.178-.379-.342-.562-.515a.82.82,0,0,0-.552-.242.654.654,0,0,0-.456.189.725.725,0,0,0-.006,1.025h0c.375.406.777.811,1.22,1.253",
    transform: "translate(-106.583 -117.239)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_666",
    "data-name": "Path 666",
    d: "M119.972,86.859a.737.737,0,0,0,.516.242.725.725,0,0,0,.487-.212c.766-.715,1.541-1.45,2.3-2.182a.428.428,0,0,0,.041-.039.673.673,0,0,0-.01-.951h0a.724.724,0,0,0-.525-.242.749.749,0,0,0-.483.19,2.047,2.047,0,0,0-.19.178l-.076.074-1.506,1.434-.162-.15c-.181-.169-.352-.329-.522-.495a.887.887,0,0,0-.6-.278.637.637,0,0,0-.44.174.684.684,0,0,0-.221.483.832.832,0,0,0,.242.595c.363.381.74.767,1.152,1.179",
    transform: "translate(-106.613 -75.052)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_667",
    "data-name": "Path 667",
    d: "M123.066,177.241a.709.709,0,0,0-.89.15c-.419.406-.846.809-1.264,1.207l-.449.427-.166-.156c-.181-.169-.351-.328-.521-.492a.884.884,0,0,0-.6-.276.637.637,0,0,0-.443.178.684.684,0,0,0-.218.483.836.836,0,0,0,.248.6c.354.37.733.755,1.153,1.178a.735.735,0,0,0,.516.242.684.684,0,0,0,.468-.21c.912-.847,1.651-1.551,2.337-2.218a.675.675,0,0,0,.21-.57.725.725,0,0,0-.381-.539",
    transform: "translate(-106.552 -159.271)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_668",
    "data-name": "Path 668",
    d: "M9.414,109.079a4.726,4.726,0,0,0-8.7-1.9,4.726,4.726,0,0,0,7.3,5.888,4.721,4.721,0,0,0,1.434-3.39v0a4.7,4.7,0,0,0-.038-.594m-.783,1.194a3.952,3.952,0,0,1-1.881,2.793,3.861,3.861,0,0,1-.629.3h0a3.948,3.948,0,1,1,2.511-3.1",
    transform: "translate(0 -94.361)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_669",
    "data-name": "Path 669",
    d: "M25.7,128.012H23.761v-1.94a.345.345,0,1,0-.689,0v1.94H21.135a.345.345,0,1,0,0,.689h1.94v1.94a.345.345,0,1,0,.689,0V128.7H25.7a.345.345,0,0,0,0-.689Z",
    transform: "translate(-18.692 -113.041)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_670",
    "data-name": "Path 670",
    d: "M59.044,158.8v0Z",
    transform: "translate(-53.086 -142.774)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTask2);
export default __webpack_public_path__ + "static/media/create-task2.fc8304acc9cc6ced59abdde96adb1e20.svg";
export { ForwardRef as ReactComponent };